import React, { forwardRef, ForwardedRef } from 'react';
import { buildButtonClass } from './helper';
import { getFilteredClasses } from '../../utils';
import { IButton } from './types';

const IconComponent = ({ icon, iconClass, iconNoMargin, size }: Pick<IButton, 'icon' | 'iconClass' | 'iconNoMargin' | 'size'>) => {
  const iconSizeClass = size === 'sm' ? 'fa-sm' : '';
  const iconMarginClass = iconNoMargin ? '' : 'mr-2';
  const filteredClasses = getFilteredClasses(['fal', `fa-${icon}`, iconMarginClass, iconSizeClass, iconClass]);

  return <i className={filteredClasses} data-testid="button-icon" />;
};

const Button = forwardRef(
  ({ children, className, control, icon, iconClass, iconNoMargin, modalId, size, type = 'button', variant, weight, ...rest }: IButton, ref: ForwardedRef<HTMLButtonElement>) => {
    const computedClass = buildButtonClass({ className, size, variant, weight });
    const dataProps = control === 'modal' ? { 'data-target': `#${modalId || 'modalId'}`, 'data-toggle': 'modal' } : {};

    return (
      <button
        className={computedClass}
        data-testid="button"
        // eslint-disable-next-line react/button-has-type
        {...{ ref, type, ...dataProps, ...rest }}
      >
        {icon && <IconComponent {...{ icon, iconClass, iconNoMargin, size }} />}
        {children}
      </button>
    );
  }
);

export { Button };
